export default __webpack_public_path__ + "assets/f55243a22cea8a135c9bc382eca23a71.ttf";